import { render } from "./BillingAddressForm.vue?vue&type=template&id=16c6039e"
import script from "./BillingAddressForm.vue?vue&type=script&lang=js"
export * from "./BillingAddressForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__